function getPrefix() {
  const config = useRuntimeConfig().public
  const prefix =
    import.meta.env.MODE === 'development'
      ? 'https://sapi-dev.jctrans.com'
      : config.SAPI_DOMAIN
  return prefix
}

/**
 * @description: 获取黑名单列表
 * @return {Object}
 */
export async function getBlackList(data: any): any {
  const { post } = useUseRequest()
  const result = await post(`/rms/front/blackList/list`, data)
  return result
}

/**
 * @description: 获取黑名单详情
 * @return {Object}
 */
export async function getBlackDetail(data: any) {
  const { post } = useUseRequest()
  const result = await post(`/rms/front/blackList/getBlackListDetail`, data)
  return result
}

/**
 * @description: 获取风控列表
 * @return {Object}
 */
export async function getRiskList(data: any) {
  const { post } = useUseRequest()
  const result = await post(`/rms/fr/guideCaseRule/list`, data)
  return result
}

/**
 * @description: 获取风控详情
 * @return {Object}
 */
export async function getRiskDetail(data: any) {
  const { post } = useUseRequest()
  const result = await post(`/rms/fr/guideCaseRule/detail`, data)
  return result
}

/**
 * 风险通知推荐列表
 * @param {*} data
 * @returns
 */
export const getRiskNoticeRecommendListApi = (data: any) => {
  const { get } = useUseRequest()
  const url =
    import.meta.env.MODE === 'development'
      ? `${getPrefix()}/rms/risk/guide/guideCase/list`
      : `${getPrefix()}/rms/risk/guide/guideCase/riskNoticeList`
  return get(url, data)
}

/**
 * 获取风控推荐列表
 * @param {*} data
 * @returns
 */
export const getRecommendListApi = (data: any) => {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/riskControl/guide/getList`, data)
}

export const getRiskCaseRecommendListApi = (data: any) => {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/risk/guide/guideCase/list`, data)
}

export const getRiskAssuranceProcessRecommendListApi = (data: any) => {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/risk/guide/guideCase/ruleList`, data)
}

export async function getGuideShareComp() {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/risk/guide/guideShareComp/list`)
}

export async function getHotListApi() {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/risk/guide/guideProblem/hotList`)
}

export async function getHotProblemListApi() {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/risk/guide/guideProblem/helpList`)
}

/**
 * 黑名单列表页
 * @param {*} data
 * @returns
 */
export const getAllBlackListApi = (data: any) => {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/riskControl/blacklist/getList`, data)
}

export const getSharingListAPi = () => {
  const { get } = useUseRequest()
  return get(`${getPrefix()}/rms/risk/guide/guideShare/list`)
}

/**
 * 访问任意risk页面时调用
 * @returns
 */
export const viewRiskAnyModuleApi = () => {
  const { post } = useUseRequest()
  return post(`/rms/fr/guideCaseRule/viewAnyMoudle`)
}
